import React from 'react'
import { Chip } from '@material-ui/core'

import useStyles from './styles'

const ActiveStatusChip = ({ active, size = 'small', ...rest }) => {
  const classes = useStyles()

  return (
    <Chip
      size={size}
      label={active ? 'ATIVO' : 'INATIVO'}
      className={active ? classes.active : classes.inactive}
      {...rest}
    />
  )
}

export default ActiveStatusChip
